module.exports = __webpack_public_path__ + "img/indicator2.e44cced0.png";